<div class="settings-map-wrapper">

  <div class="standalone-loader" *ngIf="isInitialLoading">
    <div class="spinner-border custom-blue-spinner" role="status"></div>
    <span class="loading-text">Loading map services...</span>
  </div>

  <div class="content-center" *ngIf="!isInitialLoading">

    <div class="tab-actions" [class.dimmed]="showNewInline">
      <a class="new-service-link" (click)="openNewService()">New Map Service</a>
    </div>

    <div class="new-service-inline" 
         *ngIf="showNewInline" 
         role="dialog" 
         aria-modal="true"
         [class.active-card]="isNewServiceActive()">
         
      <div class="new-service-header">
        <wm-common-text [data]="{ text: 'New Map Service' }"></wm-common-text>
        <button class="modal-close" (click)="closeNewService()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="modal-form" (ngSubmit)="saveNewService()">
        <div class="row">
          <div class="col">
            <label class="field-label">Name</label>
            <wm-common-textfield
              [data]="{ placeholder: 'Enter Name' }"
              [(ngModel)]="newService.name"
              name="new-name"
              required
            ></wm-common-textfield>
          </div>
          <div class="col">
            <label class="field-label">Service URL</label>
            <wm-common-textfield
              [data]="{ placeholder: 'Enter Service URL' }"
              [(ngModel)]="newService.endpointUrl"
              name="new-url"
              required
            ></wm-common-textfield>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label class="field-label">Map Key Value</label>
            <wm-common-textfield
              [data]="{ placeholder: 'Enter Map Key Value' }"
              [(ngModel)]="newService.mapKeyValue"
              name="new-key"
            ></wm-common-textfield>
          </div>
          <div class="col">
            <label class="field-label">&nbsp;</label>
            <button type="button" class="btn btn-get-layers btn-block" 
                    [disabled]="!newService.endpointUrl || loadingLayers['new']"
                    (click)="fetchLayers(newService, 'new')">
              <ng-container *ngIf="!loadingLayers['new']">Get Layers</ng-container>
              <ng-container *ngIf="loadingLayers['new']">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
              </ng-container>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label class="field-label">Parcel Layer</label>
            <div class="custom-select-container" [class.disabled]="!hasLayers('new')">
              <div class="input select-trigger" 
                   (click)="!hasLayers('new') ? null : toggleDropdown('new-layer')" 
                   [class.active]="activeDropdown === 'new-layer'">
                <span class="selected-text" [class.placeholder-text]="!newService.parcelLayer">
                  {{ newService.parcelLayer || 'Select Layer' }}
                </span>
                <mat-icon class="dropdown-icon">
                  {{ activeDropdown === 'new-layer' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                </mat-icon>
              </div>
              
              <div class="custom-options-list" 
                   *ngIf="activeDropdown === 'new-layer'"
                   (click)="$event.stopPropagation()">
                <div class="option-item" 
                     *ngFor="let l of availableLayers['new']" 
                     (click)="selectLayer(newService, 'new', l.name)">
                  {{ l.name }}
                </div>
              </div>
            </div>
          </div>

          <div class="col">
             <label class="field-label">Parcel ID Field</label>
             <div class="custom-select-container" 
                  [class.disabled]="!availableFields['new'] || availableFields['new'].length === 0">
               <div class="input select-trigger" 
                    (click)="(!availableFields['new'] || availableFields['new'].length === 0) ? null : toggleDropdown('new-field')"
                    [class.active]="activeDropdown === 'new-field'">
                 <span class="selected-text" [class.placeholder-text]="!newService.parcelLayerKeyField">
                   {{ newService.parcelLayerKeyField || 'Select Field' }}
                 </span>
                 <mat-icon class="dropdown-icon">
                   {{ activeDropdown === 'new-field' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                 </mat-icon>
               </div>
               
               <div class="custom-options-list" 
                    *ngIf="activeDropdown === 'new-field'"
                    (click)="$event.stopPropagation()">
                 <div class="option-item" 
                      *ngFor="let f of availableFields['new']" 
                      (click)="selectField(newService, 'new', f.name)">
                   {{ f.name }} ({{ f.alias }})
                 </div>
               </div>
             </div>
          </div>
        </div>

        <div class="form-actions modal-actions">
          <button type="button" class="btn cancel" (click)="closeNewService()">CANCEL</button>
          <button type="submit" class="btn save">SAVE</button>
        </div>
      </form>
    </div>

    <div class="services-list" [class.dimmed]="showNewInline">
      
      <div *ngIf="services.length === 0" class="no-data" style="text-align: center; padding: 40px; color: #777;">
          No map services configured.
      </div>

      <div class="service-card" 
           *ngFor="let svc of services; let i = index" 
           [id]="'svc-card-' + i"
           [class.expanded]="svc['expanded']"
           [class.active-card]="isServiceActive(i)">
        
        <div class="service-card-header" (click)="toggleAccordion(i)">
          <div class="service-title">{{ svc.name }}</div>
          <div class="header-actions" (click)="$event.stopPropagation()">
            <button class="icon-btn action-delete" title="Delete" (click)="requestDelete(svc, i)">
              <mat-icon>delete_outline</mat-icon>
            </button>
            <button class="icon-btn chevron-btn" (click)="toggleAccordion(i)">
              <mat-icon>{{ svc['expanded'] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </button>
          </div>
        </div>

        <div class="service-card-body" *ngIf="svc['expanded']">
          <form class="service-form" (ngSubmit)="saveService(i)">
            
            <div class="row">
              <div class="col">
                <label class="field-label">Name</label>
                <wm-common-textfield
                  [data]="{ placeholder: 'Enter Name' }"
                  [(ngModel)]="svc.name"
                  name="name-{{i}}"
                ></wm-common-textfield>
              </div>
              <div class="col">
                <label class="field-label">Service URL</label>
                <wm-common-textfield
                  [data]="{ placeholder: 'Enter Service URL' }"
                  [(ngModel)]="svc.endpointUrl"
                  name="url-{{i}}"
                ></wm-common-textfield>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <label class="field-label">Map Key Value</label>
                <wm-common-textfield
                  [data]="{ placeholder: 'Enter Map Key Value' }"
                  [(ngModel)]="svc.mapKeyValue"
                  name="key-{{i}}"
                ></wm-common-textfield>
              </div>
              <div class="col">
                <label class="field-label">&nbsp;</label>
                <button type="button" class="btn btn-get-layers btn-block" 
                        [disabled]="!svc.endpointUrl || loadingLayers[i]"
                        (click)="fetchLayers(svc, i)">
                  <ng-container *ngIf="!loadingLayers[i]">Get Layers</ng-container>
                  <ng-container *ngIf="loadingLayers[i]">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </ng-container>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <label class="field-label">Parcel Layer</label>
                <div class="custom-select-container" [class.disabled]="!hasLayers(i)">
                  <div class="input select-trigger" 
                       (click)="!hasLayers(i) ? null : toggleDropdown('svc-' + i + '-layer')"
                       [class.active]="activeDropdown === 'svc-' + i + '-layer'">
                    <span class="selected-text" [class.placeholder-text]="!svc.parcelLayer">
                      {{ svc.parcelLayer || 'Select Layer' }}
                    </span>
                    <mat-icon class="dropdown-icon">
                      {{ activeDropdown === 'svc-' + i + '-layer' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    </mat-icon>
                  </div>
                  
                  <div class="custom-options-list" 
                       *ngIf="activeDropdown === 'svc-' + i + '-layer'"
                       (click)="$event.stopPropagation()">
                     <div class="option-item disabled" *ngIf="!hasLayers(i)">No layers available</div>
                    <div class="option-item" 
                         *ngFor="let l of availableLayers[i]" 
                         (click)="selectLayer(svc, i, l.name)">
                      {{ l.name }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col">
                <label class="field-label">Parcel ID Field</label>
                <div class="custom-select-container" 
                     [class.disabled]="!availableFields[i] || availableFields[i].length === 0">
                  <div class="input select-trigger" 
                       (click)="(!availableFields[i] || availableFields[i].length === 0) ? null : toggleDropdown('svc-' + i + '-field')"
                       [class.active]="activeDropdown === 'svc-' + i + '-field'">
                    <span class="selected-text" [class.placeholder-text]="!svc.parcelLayerKeyField">
                      {{ svc.parcelLayerKeyField || 'Select Field' }}
                    </span>
                    <mat-icon class="dropdown-icon">
                      {{ activeDropdown === 'svc-' + i + '-field' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    </mat-icon>
                  </div>
                  
                  <div class="custom-options-list" 
                       *ngIf="activeDropdown === 'svc-' + i + '-field'"
                       (click)="$event.stopPropagation()">
                    <div class="option-item" 
                         *ngFor="let f of availableFields[i]" 
                         (click)="selectField(svc, i, f.name)">
                      {{ f.name }} ({{ f.alias }})
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button type="button" class="btn cancel" (click)="cancelEdit(i)">CANCEL</button>
              <button type="button" class="btn reindex" (click)="reindex(i)">REINDEX</button>
              <button type="submit" class="btn save">SAVE</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="dropdown-backdrop" *ngIf="activeDropdown" (click)="closeDropdown()"></div>

  <wm-common-confirmation-modal
    [data]="confirmData"
    (onYesClick)="confirmDelete()"
    (onNoClick)="cancelDelete()"
    [isApplicantMobileview]="true"
  ></wm-common-confirmation-modal>

</div>